import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  container: {
    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "12px",
    maxHeight: "90vh",
    overflowY: "auto",
    fontFamily: "Manrope !important",
    overflowX: "hidden",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    maxWidth: "628px",
  },
  wrapper: {
    height: "100%",
  },

  header: {
    padding: "24px 16px 0px 24px",
  },

  content: {},

  footer: {
    height: "72px",
    padding: "16px 24px",
    width: "100%",
    marginTop: "auto",
  },

  title: {
    color: "#344054",
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: "28px",
  },

  button: {
    height: "40px",
  },
  actionButton: {},

  menuItem: {
    color: "#667085",
    fontWeight: 600,
    fontSize: "14px",
    fontFamily: "Manrope",
    minWidth: "148px",
    height: "40px",
  },
  itemCancel: {
    color: "#F97066",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
    justifyContent: "flex-end",
  },
  icon: {
    marginTop: "2px",
    marginLeft: "4px",
  },
}));

export default styles;
